import { api } from "./api";

function sid() {
  let s = sessionStorage.getItem("k_sid");
  if (!s) {
    s = Math.random().toString(36).slice(2) + Date.now().toString(36);
    sessionStorage.setItem("k_sid", s);
  }
  return s;
}

export function source() {
  const p = new URLSearchParams(window.location.search);
  const stored = JSON.parse(sessionStorage.getItem("k_src") || "null");
  if (stored) return stored;
  const src = { utm_source: p.get("utm_source") || "", utm_campaign: p.get("utm_campaign") || "", referrer: document.referrer ? new URL(document.referrer).hostname : "" };
  sessionStorage.setItem("k_src", JSON.stringify(src));
  return src;
}

// Anonymous, cookie-less measurement; respects Do Not Track.
export function track(type, data = {}) {
  if (navigator.doNotTrack === "1") return;
  const s = source();
  api.post("/track", { type, sid: sid(), source: s.utm_source || s.referrer, ...data }).catch(() => {});
}
